var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart32P(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-32p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7010_197544",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7010_197544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shopping_cart",
    d: "M9.48449 29.3109C8.79876 29.3109 8.2133 29.0668 7.72813 28.5784C7.24293 28.0901 7.00033 27.5031 7.00033 26.8173C7.00033 26.1316 7.24449 25.5461 7.73283 25.061C8.22116 24.5758 8.80819 24.3332 9.49393 24.3332C10.1797 24.3332 10.7651 24.5773 11.2503 25.0657C11.7355 25.554 11.9781 26.141 11.9781 26.8268C11.9781 27.5125 11.7339 28.098 11.2456 28.5832C10.7573 29.0684 10.1702 29.3109 9.48449 29.3109ZM22.8178 29.3109C22.1321 29.3109 21.5466 29.0668 21.0615 28.5784C20.5763 28.0901 20.3337 27.5031 20.3337 26.8173C20.3337 26.1316 20.5778 25.5461 21.0662 25.061C21.5545 24.5758 22.1415 24.3332 22.8273 24.3332C23.513 24.3332 24.0985 24.5773 24.5837 25.0657C25.0688 25.554 25.3114 26.141 25.3114 26.8268C25.3114 27.5125 25.0673 28.098 24.5789 28.5832C24.0906 29.0684 23.5036 29.3109 22.8178 29.3109ZM7.95586 7.53317L11.467 14.8221H20.9781L24.9781 7.53317H7.95586ZM6.86699 5.31094H26.5131C27.0236 5.31094 27.4121 5.54243 27.6785 6.0054C27.9449 6.46836 27.9485 6.93317 27.6892 7.39984L23.1114 15.6443C22.867 16.0739 22.5462 16.4146 22.149 16.6665C21.7518 16.9183 21.3171 17.0443 20.8448 17.0443H10.8003L9.06699 20.2443H25.3114V22.4665H9.26699C8.31144 22.4665 7.61144 22.1128 7.16699 21.4054C6.72255 20.698 6.71885 19.9406 7.15589 19.1332L9.17813 15.4221L4.20033 4.8887H1.57812V2.6665H5.62256L6.86699 5.31094Z",
    fill: "#054BC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart32P);
export default __webpack_public_path__ + "static/media/shopping-cart-32p.41b42eedd4e97a2cf07fc37f17f9c077.svg";
export { ForwardRef as ReactComponent };